import QuickGroupAlarms from './QuickGroupAlarms';
export default QuickGroupAlarms;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickGroupAlarms/index.js